<template>
  <div class="block-material-name">
    <span class="p-float-label p-input-icon-right">
      <InputText id="material_name" type="text" v-model="material_name" :class="(material_name === '' ? 'p-invalid' : '')"/>
      <label for="material_name">Material Name</label>
    </span>

    <i class="pi pi-info-circle" style="font-size: 2rem; margin-left: 1rem;" @click="() => showInfo=true"></i>
  </div>
  <div v-if="showInfo" class="backImgIngo" @click="showInfo=false">
    <img src="@/assets/Tooltip_material+.png" class="imgInfo" @click="showInfo=false">
  </div>
  <br/>
</template>

<script>

export default {
  name: 'NameMaterial',
  props: {
    msg: String
  },
  data() {
    return {
      material_name: '',
      showInfo: false
    }
  },
  methods: {},
  watch: {
    material_name() {
      this.$emit('name', this.material_name)
      console.log(this.material_name)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.backImgIngo {
  width: 100%;
  height: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.2);
  z-index: 1000;
}

.imgInfo {
  background-color: white;
  height: calc(100vh / 1.5);
  margin-top: calc((100% - 65%)/4);
}

ul {
  list-style-type: circle !important;
  padding: 0;
}

li {
  margin: 0 10px;
}

a {
  color: #42b983;
}

.block-material-name {
  display: flex;
  margin: auto;
  justify-content: center;
}

</style>
